module.exports = __webpack_public_path__ + "static/media/education-object-1-3-1.a5872719.svg";